// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WarningRow_row__4KcCz {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.WarningRow_icon__sNoJc {
  width: 2rem;
  height: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/PortalModal/WarningRow.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF","sourcesContent":[".row {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.icon {\n  width: 2rem;\n  height: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `WarningRow_row__4KcCz`,
	"icon": `WarningRow_icon__sNoJc`
};
export default ___CSS_LOADER_EXPORT___;
